<template>
    <div>
        <MenuProducts/>
        <Product_LowCost/>
    </div>
</template>

<script>
    import MenuProducts from "@/components/admin/manage_products/menuproducts/MenuProducts.vue";
    import Product_LowCost from "@/components/admin/manage_products/Product_LowCost.vue";
    export default {
        name: "ProductLowCost",
        components: {
            Product_LowCost,
            MenuProducts
        }
    }
</script>

<style scoped>

</style>
